<app-auto-dispatch-grid (mySelected)="grid_onSelected($event)"></app-auto-dispatch-grid>

